module.exports = __webpack_public_path__ + "img/revoke.1ee9be41.png";